// 匈牙利语言
const hu = {
  common: {
    notSupport: 'A böngésző nem támogatja a teljes képernyős módot',
    loadFail: 'A téma betöltése sikertelen',
    noPermission: 'Sajnáljuk, nincs jogosultsága az oldal megtekintéséhez',
    backHome: 'Vissza a kezdőlapra',
    noExit: 'A megnyitni kívánt oldal nem létezik',
    serverError: 'Sajnáljuk, a szerver hibát észlelt',
    slide: 'Húzza jobbra',
    veryHigh: 'Nagyon magas',
    high: 'Magas',
    target: 'Cél',
    urgentLow: 'Nagyon alacsony',
    agpNoData:
      'Az AGP jelentés elkészítéséhez legalább 5 napnyi adat szükséges',
    noDataStr: 'Nincs adat',
    setting: 'Beállítás',
    personInfo: 'Alapinformációk',
    updatePwd: 'Jelszó módosítása',
    upHead: 'Képek feltöltése',
    inRange: 'Tartományon belül',
    normal: 'Normál',
    low: 'Alacsony',
    previous: 'Előző',
    next: 'Következő',
    search: 'Keresés',
    reset: 'Visszaállítás',
    cancel: 'Mégse',
    ok: 'Rendben',
    confirm: 'Megerősítés',
    save: 'Mentés',
    submit: 'Beküldés',
    successful: 'Sikeres',
    pleaseEnter: 'Kérjük, adja meg',
    pleaseSelect: 'Kérjük, válasszon',
    success: 'Sikerült',
    confirmLogout: 'Biztos, hogy ki szeretne jelentkezni?',
    updateSuccessed: 'Frissítés sikeres',
    warning: 'Figyelmeztetés',
    date: 'Dátum',
    start: 'Kezdés',
    end: 'Befejezés',
    sevenDays: '7 nap',
    fourteenDays: '14 nap',
    thirtyDays: '30 nap',
    signOut: 'Kijelentkezés',
    personalInformation: 'Személyes adatok',
    email: 'E-mail',
    name: 'Név',
    mobile: 'Mobil',
    dateOfBirth: 'Születési dátum',
    gender: 'Nem',
    diabeteType: 'Diabétesz típusa',
    dateOfDignose: 'Diagnózis éve',
    remarks: 'Megjegyzés',
    optionMale: 'Férfi',
    optionFemale: 'Nő',
    optionUnknow: 'Nem szeretném megadni',
    noDiabetes: 'Nincs diabétesz',
    diabeteTypeI: '1-es típus',
    diabeteTypeII: '2-es típus',
    diabeteSpecial: 'Speciális',
    diabeteGestational: 'Terhességi diabétesz',
    diabeteOthers: 'Egyéb',
    ruleMsgEmail: 'Kérjük, adja meg az e-mail címet',
    ruleMsgName: 'Kérjük, adja meg a nevet',
    ruleMsgMobile: 'Kérjük, adja meg a mobilszámát',
    ruleMsgBirthday: 'Kérjük, válassza ki a születési dátumot',
    ruleMsgSex: 'Kérjük, válassza ki a nemet',
    ruleMsgDiabeteType: 'Kérjük, válassza ki a diabétesz típusát',
    ruleMsgDateOfDignose: 'Kérjük, válassza ki a diagnózis évét',
    ruleMsgRemarks: 'Kérjük, írja be a megjegyzést',
    ruleMsgCorrectMobile: 'Kérjük, adjon meg érvényes mobilszámot',
    oldPassword: 'Régi jelszó',
    newPassword: 'Új jelszó',
    confirmPassword: 'Jelszó megerősítése',
    ruleMsgOldPassword: 'Kérjük, adja meg a régi jelszót',
    ruleMsgNewPassword: 'Kérjük, adja meg az új jelszót',
    ruleMsgConfirmPassword: 'Kérjük, erősítse meg a jelszót',
    passwordInconsistent: 'A két jelszó nem egyezik',
    passwordModifySuccessed:
      'A jelszót visszaállítottuk, kérjük, jelentkezzen be újra!',
    monday: 'Hétfő',
    tuesday: 'Kedd',
    wednesday: 'Szerda',
    thursday: 'Csütörtök',
    friday: 'Péntek',
    saturday: 'Szombat',
    sunday: 'Vasárnap',
    sn: 'Sorozatszám',
    startDate: 'Kezdő dátum',
    days: 'nap',
    pdfDate: 'Cél',
    close: 'bezárás',
    inputTip: 'Kérjük, adjon meg kulcsszavakat a kereséshez',
    polarization: 'Eszköz inicializálása',
    hour: 'ó',
    minutes: 'perc',
    seconds: 'mp',
    reportDownLoadTip: 'A jelentése még nem készült el 5 napja',
    age: 'Életkor',
    goal: 'Cél',
    expired: 'Szenzor lejárt',
    lastTime: 'Utolsó frissítési idő',
    timeZone: 'Időzóna'
  },
  route: {
    login: 'Bejelentkezés',
    forget: 'Elfelejtett jelszó',
    home: 'Főoldal',
    glucoseReport: 'Glükózjelentés',
    sessionReport: 'Mérési időszak jelentés',
    eventList: 'Eseménylista',
    followerList: 'Követőlista',
    followerListQ: 'Megfigyelői kérelem',
    settings: 'Beállítások',
    profile: 'Profil'
  },
  login: {
    rememberMe: 'Emlékezz rám',
    forgetPassword: 'Elfelejtett jelszó',
    agree: 'A bejelentkezéssel elfogadja a FurCarer feltételeit',
    privacyPolicy: 'Adatvédelmi irányelvek',
    CGMUser: 'CGM-felhasználó',
    follower: 'Követő',
    ruleMsgPassword: 'Kérjük, adja meg a jelszót',
    login: 'Bejelentkezés',
    phonePlacehold: 'Kérjük, adja meg a telefonszámot',
    codePlacehold: 'Kérjük, adja meg az ellenőrző kódot',
    codePlaceholdInput: 'Kérjük, adja meg t...',
    phoneTip: 'Telefonon',
    emialTip: 'E-mailben',
    codeTip: 'Ellenőrző kód lekérése',
    reGetTip: 'Újrakérés'
  },
  layout: {
    collapseUp: 'Menü elrejtése',
    collapseDown: 'Menü kibontása',
    refresh: 'Frissítés',
    backHome: 'Főoldal',
    helpCenter: 'Súgóközpont',
    fullScreen: 'Teljes képernyő'
  },
  forget: {
    ruleMsgCode: 'Kérjük, adja meg a kódot',
    sendCode: 'Kód küldése',
    tipsMsgSendSuccess: 'Az ellenőrző kód sikeresen elküldve!',
    tipsMsgModifySuccess: 'Jelszómódosítás sikeres'
  },
  home: {
    title: 'FurCarer Portal',
    todaysGlucose: 'Mai glükóz',
    todaysOverview: 'Mai áttekintés',
    maxGlucose: 'Max. glükóz',
    minGlucose: 'Min. glükóz',
    avgGlucose: 'Átl. glükóz',
    maxmumVariation: 'Maximális eltérés',
    glucose: 'Glükóz',
    tir: 'TIR',
    latestGlucose: 'Legutóbbi glükóz',
    todayPercentage:
      'A mai nap százalékos megoszlása különböző tartományok szerint',
    fourHour: '4 óra',
    eightHour: '8 óra',
    twelveHour: '12 óra',
    twentyFourHour: '24 óra',
    glucoseOnly: 'Csak glükóz',
    sessionOverview: 'Mérési időszak áttekintés',
    glocuseMetrics: 'Glükóz metrikák',
    agp: 'AGP',
    dailyGlucose: 'Napi glükóz',
    sessionGlucose: 'Mérési időszak glükóz',
    standTir: 'Alapértelmezett TIR',
    customTir: 'Egyéni TIR',
    cancleGz: 'Követés megszüntetése',
    cancleText: 'Biztosan megszünteti a jelenlegi felhasználó követését?',
    helpCenterTip: 'A funkció még nem elérhető'
  },
  glucoseReport: {
    statics: 'Statisztika',
    sixHour: '6 órás TIR',
    avgGlucose: 'Átlagos glükóz',
    maxGlucose: 'Maximális glükóz',
    minGlucose: 'Minimális glükóz',
    cv: 'CV',
    high: 'Magas értékek száma',
    low: 'Alacsony értékek száma',
    normal: 'Normál értékek száma',
    tir: 'TIR',
    estimatedA1c: 'Becsült HbA1c',
    min: 'Min',
    avg: 'Átlag',
    max: 'Max',
    maxVariation: 'Maximális eltérés'
  },
  glucoseProfile: {
    avg: 'Átlag',
    sd: 'Szórás (SD)',
    cv: 'CV'
  },
  eventList: {
    all: 'Összes',
    bg: 'BG',
    meal: 'Étkezés',
    sport: 'Sport',
    insulin: 'Inzulin',
    alert: 'Riasztás',
    eventType: 'Esemény típusa',
    description: 'Leírás',
    note: 'Megjegyzés',
    highAlert: 'riasztási figyelmeztetés',
    calibration: 'Kalibrálás',
    meds: 'Gyógyszerek',
    time: 'Idő',
    detail: 'Részletek',
    weigt: 'Súly'
  },
  followerList: {
    title: 'Monitorozott felhasználók',
    tabTitle: 'Követőkezelés',
    refreshText:
      'Automatikus frissítés (a felhasználói lista 30 másodpercenként automatikusan frissül)',
    addText: 'Hozzáadás',
    dataText: 'Adatok lekérve',
    timeText: 'perc',
    hourText: 'óra',
    agoText: ' ezelőtt',
    tableEmail: 'Adja meg a fiókszámot',
    searchPlacehold: 'Kérjük, adja meg a fiókszámot a kereséshez',
    pending: 'Függőben',
    approved: 'Jóváhagyva',
    rejected: 'Elutasítva',
    addFollower: 'Követő hozzáadása',
    editFollower: 'Követő szerkesztése',
    tableName: 'Név',
    tableAddTime: 'Hozzáadás ideje',
    tableStatus: 'Állapot',
    tableApproved: 'Jóváhagyva',
    tableReject: 'Elutasítás',
    tableStartSharing: 'Megosztás indítása',
    tableStopSharing: 'Megosztás leállítása',
    op: 'Művelet',
    sharing: 'Megosztás',
    notSharing: 'Nem megosztott',
    tableRemove: 'eltávolítás',
    note: 'Megjegyzés',
    message: 'Üzenet',
    ruleMsgEmailEmpty: 'Kérjük, adja meg az e-mail címet a kereséshez',
    ruleMsgNote: 'Kérjük, írja be a megjegyzést',
    ruleMsgMessage: 'Kérjük, hagyjon üzenetet',
    ruleMsgEmailCorrect: 'Kérjük, adjon meg egy érvényes e-mail címet',
    formAcknowledge:
      'Tudomásul veszem, hogy követő hozzáadásával ez a felhasználó láthatja az adataimat',
    sendFollowRequest: 'Követési kérelem küldése',
    setNote: 'Megjegyzés beállítása',
    tipsAcknowledge:
      'Kérjük, jelölje be a négyzetet, amellyel elismeri, hogy a követő hozzáadásával ez a felhasználó láthatja az adatait',
    stopSharing: 'Megosztás leállítása',
    startSharing: 'Megosztás indítása',
    removeUser: 'Felhasználó eltávolítása',
    confirmStopSharing:
      'Biztosan leállítja a glükóz megosztását ezzel a felhasználóval?',
    confirmStartSharing:
      'Biztosan el szeretné kezdeni a glükóz megosztását ezzel a felhasználóval?',
    confirmRemove:
      'Biztosan el szeretné távolítani ezt a felhasználót a listáról?',
    approvedFollower: 'Jóváhagyott követő',
    rejectFollower: 'Követő elutasítása',
    confirmApproved: 'Biztosan jóváhagyja ezt a követési kérelmet?',
    confirmReject: 'Biztosan elutasítja ezt a követési kérelmet?',
    addTime: 'Hozzáadás ideje',
    check: 'Ellenőrzés',
    remove: 'Eltávolítás',
    removeUserTitle:
      'Biztosan el szeretné távolítani ezt a felhasználót a listáról?'
  },
  settings: {
    title: 'Glükózszint beállítások',
    unitSet: 'Egység beállítása',
    targetSet: 'Egyéni TIR beállítás',
    alertSet: 'Riasztási beállítás',
    highAlert: 'Magas riasztás',
    lowAlert: 'Alacsony riasztás',
    urgentLow: 'Sürgősen alacsony',
    urgentHigh: 'Sürgősen magas',
    target: 'Cél'
  },
  pdf: {
    dailyStatistics: 'Napi statisztika',
    title: 'AGP jelentés',
    page: 'Oldal',
    generated: 'Generálva',
    lage: 'LAGE',
    mage: 'MAGE',
    modd: 'MODD',
    range: 'Időtartam a célérték-tartományban',
    timeInRange: 'Időtartam a célérték-tartományban (TIR)',
    agpTitle: 'Ambuláns Glükózprofil (AGP)',
    agpSubTitle:
      'Az AGP a jelentési időszak glükózértékeinek összegzése, amely a mediánt (50%) és más percentiliseket úgy jelenít meg, mintha egyetlen nap alatt történtek volna',
    dailyTitle: 'Napi glükózprofil',
    dailySubTitle:
      'Minden napi profil éjféltől éjfélig tartó időszakot képvisel.',
    device: 'Eszköz',
    tDevice: 'Végberendezés',
    print: 'Nyomtatás',
    model: 'Modell',
    deviceSn: 'Eszköz sorozatszáma',
    effectiveData: 'Érvényes adatok',
    days: 'Napok',
    appVer: 'Alkalmazás verziója',
    smartPhoneModel: 'Okostelefon modell',
    osVersion: 'Operációs rendszer verziója',
    appSetting: 'Alkalmazás beállítása',
    GoalsforType1andType2Diabetes:
      'Célkitűzések 1-es és 2-es típusú diabétesz esetén',
    Each1timeinrange15minutes: 'Minden 1% idő a tartományban ≈ 15 perc',
    note: 'Megjegyzés: A % egység a DCCT szabvány szerint használatos, az mmol/mol egység pedig az IFCC szabvány szerint.',
    DOB: 'Születési dátum',
    SN: 'Sorozatszám'
  },
  field: {
    timeCgmActive: 'CGM aktív időtartama',
    gmi: 'GMI',
    gri: 'GRI',
    eHbA1c: 'eHbA1c',
    avgPerDay: 'Átlagos kalibrálás naponta',
    glucoseAbility: 'Glükóz ingadozás',
    lage: 'LAGE',
    mage: 'MAGE',
    tar: 'TAR',
    tbr: 'TBR',
    calibrations: 'Kalibrálások száma'
  },
  agp: {
    agpTitle: 'Ambuláns Glükózprofil (AGP)',
    centerLine: 'Medián',
    areaLine: 'Intervallum',
    target: 'Céltartomány'
  },
  basic: {
    customTir: 'Egyéni TIR',
    bloodTip: 'Glükóz emlékeztető beállításai',
    bloodUnit: 'Glükóz egység',
    highTip: 'Magas glükóz riasztás',
    lowTip: 'Alacsony glükóz riasztás',
    unitText: 'Automatikus beállítás az ország/régió alapján',
    selectTip:
      'Kattintson az ikonra a megfelelő dátum kijelöléséhez vagy törléséhez',
    selectAll: 'Összes kiválasztása'
  },
  report: {
    threeMonth: 'Elmúlt 3 hónap',
    sixMonth: 'Közel 6 hónap',
    yearText: 'Elmúlt év',
    showAll: 'Összes megjelenítése',
    all: 'Összes',
    selectDate: 'Dátumtartomány kiválasztása',
    to: 'eddig',
    startDt: 'Kezdő dátum',
    endDt: 'Befejező dátum',
    betaTest: 'Bétatesztelés',
    bloodData: 'Glükóz adatok',
    userCount: 'Felhasználói fiók'
  },
  petDetail: {
    variety: 'Fajta',
    type: 'Inzulintípus',
    freq: 'Inzulin gyakorisága',
    lente: 'Lente',
    insulin: 'Inzulin glargin',
    pzi: 'PZI',
    nph: 'NPH',
    detemir: 'Detemir'
  },
  pdfReport: {
    title: 'AGP jelentés',
    snNumber: 'Sorozatszám (SN)',
    page: 'Oldal',
    createTime: 'Generálva',
    petInfo: 'Háziállat adatai',
    petName: 'Háziállat neve',
    birthday: 'Születési dátum',
    freq: 'Inzulin gyakorisága',
    petType: 'Háziállat típusa',
    age: 'Életkor',
    registerType: 'Fecskendő típusa',
    basicBloodData: 'Glükóz metrikák',
    dbText: 'Időtartam a célérték-tartományban (TIR)',
    target: 'Célkitűzések 1-es és 2-es típusú diabétesz esetén',
    recordTime: 'Rögzítési idő',
    tag: 'címke',
    event: 'Esemény',
    eventDetail: 'Esemény részletei',
    mulityText: 'Többnapos glükóz trenddiagram',
    mulitySubText:
      'A többnapos glükózprofilok az eszköz egy ciklusának időtartamát képviselik',
    avageBlood: 'Átlagos glükóz',
    bloodText: 'MODD',
    highTip: 'Magas glükóz riasztás',
    lowTip: 'Alacsony glükóz riasztás',
    cat: 'Macska',
    dog: 'Kutya',
    country: 'Ország',
    insulinDose: 'Inzulin adag',
    weightUnit: 'kg'
  },
  eventDetail: {
    Empty: 'Üres',
    Breakfast: 'Reggeli',
    Lunch: 'Ebéd',
    Dinner: 'Vacsora',
    Before_Sleep: 'Alvás előtt',
    Extra: 'Extra',
    Short_acting: 'Gyors hatású',
    Pre_mixed: 'Előkevert',
    Long_acting: 'Hosszú hatású',
    Middle_acting: 'Közepes hatású',
    hour: 'hóra',
    minutes: 'perc',
    After_Breakfast: 'Reggeli után',
    Before_Lunch: 'Ebéd előtt'
  }
};
export default hu;
